import React, { useState } from "react";
import styled from "styled-components";
import { Button, Drawer, Radio } from 'antd';
import { withRouter } from 'react-router-dom';
import "antd/dist/antd.css";
import {
    SettingFilled,
} from '@ant-design/icons';

import { useStore } from 'react-context-hook';


const ControlWrapper = styled.div`
    position: fixed;
    padding-bottom: 16px;
    padding-right: 16px;
    bottom: 0;
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 16px;
`;

const StyledButton = styled(Button)`
    margin: 2px;
`;

const SettingsButton = styled(Button)`
    position: absolute;
    right: 16px;
    bottom: 16px;
`;

const ControlButtons = ({ history }) => {
    let apiHost = 'http://127.0.0.1:8000';
    if (process.env.NODE_ENV === 'production') {
        apiHost = 'https://tichu-backend.herokuapp.com';
    }
    const [gameState, ] = useStore('game', {});
    const [, setSetup] = useStore('setup', {});

    const { done } = gameState;

    const [, setPlayer] = useStore('player', 0);
    const onReset = () => {
        if (window.gtag) {
            window.gtag('event', 'reset', {
                'event_category': 'button',
                'event_label': 'Reset Game Button Pressed',
            });
        }
        fetch(apiHost + '/reset')
            .then(res => res.json())
            .then(() => {
                setSetup(true);
            })
            .catch(console.log);
    };

    const onPlayerSwitch = (e) => {
        setPlayer(e.target.value);
    }

    const onNext = () => {
        fetch(apiHost + '/next')
            .then(res => res.json())
            .then(() => {
            })
            .catch(console.log);
    };

    const [visible, setVisible] = useState(false);
    const showDrawer = () => {
        setVisible(true);
    };
    const onClose = () => {
        setVisible(false);
    };

    return (
        <>
            <SettingsButton type="primary" icon={<SettingFilled />} onClick={showDrawer} shape="circle" />
            <Drawer
                title="Settings Menu"
                placement="right"
                closable={true}
                onClose={onClose}
                visible={visible}
            >
                <ControlWrapper>
{/*                    Switch Player
                    <Radio.Group onChange={onPlayerSwitch} defaultValue={0} buttonStyle="solid">
                        <Radio.Button value={0}>0</Radio.Button>
                        <Radio.Button value={1}>1</Radio.Button>
                        <Radio.Button value={2}>2</Radio.Button>
                        <Radio.Button value={3}>3</Radio.Button>
                    </Radio.Group>*/}
                    <ButtonWrapper>
{/*                        <StyledButton type="primary" disabled={done} onClick={onNext}>Next Random</StyledButton>
                        <StyledButton type="primary" onClick={() => history.push('/hidden')}>Prediction View</StyledButton>*/}
                        <StyledButton type="primary" danger onClick={onReset}>Reset Game</StyledButton>
                    </ButtonWrapper>
                </ControlWrapper>
            </Drawer>
        </>
    );
};

export default withRouter(ControlButtons);